import React, { useState } from "react";
import "../InsightMenu/InsightPreview.scss";
import DownloadPreview from "../../../assets/images/download-report-preview.png";

const DownloadReportPreview = () => {
    return (
        <div className="download-report-preview">
            <img alt="" src={DownloadPreview} className="download-preview-img w-100" />
            {/* HEADER */}
            {/* <div className="download-table-header">
                <div>Type</div>
                <div>Description</div>
                <div>Last Downloaded</div>
                <div className="text-center">Action</div>
            </div> */}

            {/* ROW 1 */}
            {/* <div className="download-row">
                <div>Raw Data</div>
                <div>RAW Data Excel</div>
                <div>2022-10-20 07:01 PM</div>
                <div className="actions">
                    <button className="btn-outline">Create</button>
                    <span className="icon">⟳</span>
                </div>
            </div> */}

            {/* ROW 2 */}
            {/* <div className="download-row">
                <div>Score Sheet</div>
                <div>Score Sheet Excel</div>
                <div>N/A</div>
                <div className="actions">
                    <button className="btn-outline">Create</button>
                    <span className="icon">⟳</span>
                </div>
            </div> */}

            {/* ROW 3 (Expandable) */}
            {/* <div className="download-row">
                <div>Manager Score Card Report</div>
                <div>Manager Score Card Excel</div>
                <div>N/A</div>
                <div className="actions">
                    <button className="btn-outline">Create</button>
                    <span className="icon">⟳</span>
                </div>
            </div> */}
        </div>
    );
};

export default DownloadReportPreview;